import { CircularProgress } from '@mui/material';

import ImersiveLogoDark from '../../assets/vertical-immersive-logo-dark.svg';

import './styles.scss';

const Loading = () => {
  return (
    <div className="loading-container">
      <div>
        <img src={ImersiveLogoDark} alt="Immersive finance" className="logo" />
      </div>
      <div>
        <CircularProgress size={24} />
      </div>
    </div>
  );
};

export default Loading;
